import React, { FC } from "react";

import { TrackingLinkContainer } from "containers/shared/generic/tracking-link/tracking-link-container";

import { TRACKING_CATEGORY } from "constants/tracking";
import { APP_STORE_ANDROID } from "constants/app-store-link";

import styles from "./google-app-badge.module.scss";
import { usePlansContext } from "store/plans/plans-context-provider";

export const GoogleAppBadgeContainer: FC = () => {
  const { selectedCity } = usePlansContext();

  return (
    <div className={styles.root}>
      <TrackingLinkContainer
        trackingData={{
          category: TRACKING_CATEGORY.USER_CLICK_ACTION,
          action: "Click on Google app download button",
          label: `User's selected city: ${selectedCity?.name ?? "All cities"}`,
        }}
        className={styles.link}
        href={APP_STORE_ANDROID}
        target={"_blank"}
        rel="noreferrer"
      >
        <img
          className={styles.buttonImage}
          alt="Get it on Google Play"
          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
        />
      </TrackingLinkContainer>
    </div>
  );
};
